var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${_vm.contentWidth}px`),attrs:{"id":"content"}},[_c('PageHeader'),_c('div',{staticClass:"main-content",style:(`min-width:${_vm.contentWidth}px`)},[_c('router-view')],1),_c('PageBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }